import React, { useState, type FC } from 'react';
import { Navbar as NavbarDaisy } from 'react-daisyui';
import { Search } from '../search';
import { Links } from './components/links';
import { Logo } from './components/logo';
import { MenuButton } from './components/menu-button';
import { Sidebar } from './components/sidebar';
import type { NavBarProps } from './types';

const Navbar: FC<NavBarProps> = ({ displaySearch = true, postTranslatedSlugs }) => {
    const [isOpen, setOpen] = useState(false);

    return (
        <>
            <NavbarDaisy
                className={`bg-white shadow-sm border-b-[1px] border-solid border-gray-200 
                    flex flex-wrap w-full items-center justify-center py-0 fixed z-10 sm:mb-[10px]`}
            >
                <NavbarDaisy.Start>
                    <MenuButton isOpen={isOpen} setOpen={setOpen} />
                    <Logo />
                </NavbarDaisy.Start>
                <NavbarDaisy.End>
                    <div className="flex justify-end items-center">
                        {displaySearch && (
                            <div className="header-search mx-4 relative hidden sm:block">
                                <Search />
                            </div>
                        )}
                        <Links postTranslatedSlugs={postTranslatedSlugs} />
                    </div>
                </NavbarDaisy.End>
                {displaySearch && (
                    <div className="w-full sm:hidden md:w-3/4">
                        <Search />
                    </div>
                )}
            </NavbarDaisy>
            <Sidebar isOpen={isOpen} displaySearch={displaySearch} />
        </>
    );
};

export default Navbar;
